import { dramaMeta, stats } from '@/mocks/drama';

export default function Hero() {
  return (
    <section id="home" className="relative flex min-h-[620px] w-full items-center overflow-hidden md:min-h-[760px]">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Moody%20cinematic%20night%20cityscape%20with%20deep%20crimson%20and%20amber%20light%2C%20rain%20slick%20streets%2C%20hazy%20smoke%2C%20dramatic%20chiaroscuro%20lighting%2C%20mysterious%20urban%20suspense%20atmosphere%2C%20no%20people%2C%20high%20contrast%2C%20editorial%20film%20still&width=1920&height=1080&seq=desire-hero-cinematic-01&orientation=landscape"
          alt=""
          className="h-full w-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/85 via-foreground-950/65 to-foreground-950/90" />
      </div>

      <div className="relative z-10 mx-auto w-full max-w-7xl px-4 pb-16 pt-32 md:px-6 md:pb-24 md:pt-40">
        <div className="max-w-3xl">
          <div className="inline-flex items-center gap-2 rounded-full border border-white/20 bg-white/10 px-3 py-1.5 text-xs tracking-wide text-white/85 backdrop-blur">
            <i className="ri-movie-2-line text-accent-400" />
            {dramaMeta.genre}
          </div>

          <h1 className="mt-6 font-heading text-4xl font-black leading-tight text-white md:text-6xl">
            {dramaMeta.name}
          </h1>
          <p className="mt-4 font-heading text-lg text-accent-300 md:text-2xl">{dramaMeta.tagline}</p>

          <p className="mt-6 max-w-2xl text-sm leading-relaxed text-white/80 md:text-base">
            这里整理了《{dramaMeta.name}》的演员表、主演是谁、角色介绍与人物关系，涵盖女主角与主要角色。
            想快速了解这部剧讲了什么、有哪些人、彼此是什么关系，从这里开始就可以。
          </p>

          <div className="mt-8 flex flex-col gap-3 sm:flex-row">
            <a
              href="#cast"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-list-check-2" />
              查看演员表
            </a>
            <a
              href="#characters"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-white/25 bg-white/10 px-6 py-3 text-sm font-medium text-white backdrop-blur transition-colors hover:bg-white/20"
            >
              <i className="ri-user-star-line" />
              认识主要角色
            </a>
          </div>

          <div className="mt-10 flex flex-wrap gap-x-6 gap-y-3 text-sm text-white/75">
            <span className="inline-flex items-center gap-2">
              <i className="ri-play-circle-line text-accent-400" />
              {dramaMeta.platform}
            </span>
            <span className="inline-flex items-center gap-2">
              <i className="ri-list-check-3 text-accent-400" />
              {dramaMeta.episodes}
            </span>
            <span className="inline-flex items-center gap-2">
              <i className="ri-layout-grid-line text-accent-400" />
              {dramaMeta.units}
            </span>
          </div>
        </div>

        <div className="mt-14 grid grid-cols-2 gap-4 border-t border-white/15 pt-8 md:grid-cols-4">
          {stats.map((item) => (
            <div key={item.label}>
              <div className="font-heading text-2xl font-bold text-white md:text-3xl">{item.value}</div>
              <div className="mt-1 text-xs tracking-wide text-accent-300 md:text-sm">{item.label}</div>
              <div className="mt-1 hidden text-xs text-white/60 md:block">{item.desc}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}